import React from 'react';
import { s as styles } from '../audio.rtlignore-893be7da.js';
import '../style-inject.es-746bb8ed.js';

const Duration = ({ seconds }) => {
  return /* @__PURE__ */ React.createElement("time", { dateTime: `P${Math.round(seconds)}S` }, format(seconds));
};
function format(seconds) {
  const date = new Date(seconds * 1e3);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
}
function pad(string) {
  return ("0" + string).slice(-2);
}
const AudioDuration = ({
  elapsed,
  duration,
  isMobile,
  isSmallWidth
}) => {
  const shouldRenderElapsed = !(isMobile || isSmallWidth);
  return /* @__PURE__ */ React.createElement("div", { className: styles.audio_duration }, shouldRenderElapsed && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Duration, { seconds: elapsed }), " /"), /* @__PURE__ */ React.createElement(Duration, { seconds: duration }));
};

export { AudioDuration as default };
//# sourceMappingURL=AudioDuration.js.map
